module.exports = __webpack_public_path__ + "img/device_mousedongle.9e24f023.png";